import script from "./LiTree.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiTree.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__